import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import React, { Suspense } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';

import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Queue from './pages/Queue';
import Profile from './pages/Profile';
import Shop from './pages/Shop';
import Inventory from './pages/Inventory';
import Leaderboard from './pages/Leaderboard';
import Matches from './pages/Matches';
import Stats from './pages/Stats';
import AuthCallback from './pages/AuthCallback';
import CustomLobby from './pages/CustomLobby';
import Settings from './pages/Settings';
import ReportBug from './pages/ReportBug';
import SiteBetaGate from './components/SiteBetaGate';

const Admin = React.lazy(() => import('./pages/Admin'));


function LandingOrDashboard() {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading">Loading...</div>;
  if (user) return <Navigate to="/dashboard" />;
  return <Landing />;
}

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading">Loading...</div>;
  return user ? <Layout>{children}</Layout> : <Navigate to="/login" />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <SiteBetaGate>
        <Routes>
          <Route path="/" element={<LandingOrDashboard />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/queue" element={<PrivateRoute><Queue /></PrivateRoute>} />
          <Route path="/profile/:username" element={<PrivateRoute><Profile /></PrivateRoute>} />
          <Route path="/shop" element={<PrivateRoute><Shop /></PrivateRoute>} />
          <Route path="/inventory" element={<PrivateRoute><Inventory /></PrivateRoute>} />
          <Route path="/leaderboard" element={<PrivateRoute><Leaderboard /></PrivateRoute>} />
          <Route path="/matches" element={<PrivateRoute><Matches /></PrivateRoute>} />
          <Route path="/matches/:matchId" element={<PrivateRoute><Matches /></PrivateRoute>} />
          <Route path="/stats" element={<PrivateRoute><Stats /></PrivateRoute>} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/custom" element={<PrivateRoute><CustomLobby /></PrivateRoute>} />
          <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
          <Route path="/report-bug" element={<PrivateRoute><ReportBug /></PrivateRoute>} />
          <Route
            path="/admin"
            element={(
              <PrivateRoute>
                <Suspense fallback={<div className="loading">Loading...</div>}>
                  <Admin />
                </Suspense>
              </PrivateRoute>
            )}
          />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        </SiteBetaGate>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
